import TraversableMenu from 'traversable_menu';
const transitionAuto = require('@alexspirgel/transition-auto');

function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    let context = this;
		let args = arguments;
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    }, wait);
    if (callNow) func.apply(context, args);
  }
}

function setGlobalVH() {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function setCookie(name, value, days) {
	var expires = "";
	if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}
function deleteCookie(name) {   
	document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

Drupal.behaviors.global = {
	attach: function (context, settings) {
		once('siteheader', 'body', context).forEach(
			function (element) {
				setGlobalVH();
				const debouncedWindowResize = debounce(setGlobalVH, 100);
				window.addEventListener('resize', debouncedWindowResize);
			}
		);
	}
};

class SiteHeader {

	static get mobileMediaQuery() {
		return '(max-width: 64rem)';
	}

	static get desktopSearchOpenClass() {
		return 'desktop-search-open';
	}

	static get headerReadyForTransitionClass() {
		return 'header-ready-for-transition';
	}

	static get mobileNavOpenClass() {
		return 'mobile-nav-open';
	}

	constructor(siteHeaderElement) {
		this.siteHeaderElement = siteHeaderElement;
		this.contentOverlayElement = document.querySelector('.content-overlay');
		if (siteHeaderElement) {
			this.navigationContainerElement = this.siteHeaderElement.querySelector('.site-header__navigation-container');
			if (this.navigationContainerElement) {
				this.megaMenuElements = this.navigationContainerElement.querySelectorAll('.mega-menu');
				this.formContainerElement = this.navigationContainerElement.querySelector('.views-exposed-form');
				if (this.formContainerElement) {
					this.textInputElement = this.formContainerElement.querySelector('input[type="text"]');
					this.submitInputElement = this.formContainerElement.querySelector('input[type="submit"]');
					this.closeSearchElement = this.formContainerElement.querySelector('.close-search');
				}
			}
			this.mobileNavTriggerContainerElement = this.siteHeaderElement.querySelector('.site-header__mobile-nav-trigger-container');
			if (this.mobileNavTriggerContainerElement) {
				this.mobileNavTriggerElement = this.mobileNavTriggerContainerElement.querySelector('.site-header__mobile-nav-trigger');
			}
		}
		this.siteHeaderElement.classList.add(this.constructor.headerReadyForTransitionClass);

		this.debouncedWindowResizeHandler();
		window.addEventListener('resize', this.debouncedWindowResizeHandler);

		this.contentOverlayElement.addEventListener('click', this.closeMobileNav);
	}

	debouncedWindowResizeHandler = debounce(() => {
		if (this.isMobile && this.initializedState !== 'mobile') {
			this.initializeMobileHeader();
		}
		else if (!this.isMobile && this.initializedState !== 'desktop') {
			this.initializeDesktopHeader();
		}
	}, 100)

	get isMobile() {
		const mediaQuery = window.matchMedia(this.constructor.mobileMediaQuery);
		return mediaQuery.matches;
	}

	//
	// Desktop
	//

	updateDesktopMegaMenuTop = () => {
		const paddingOffset = 12;
		if (!this.isMobile && this.megaMenuElements.length > 0) {
			this.bottomFromTopOfViewport = this.siteHeaderElement.getBoundingClientRect().bottom;
			for (const megaMenuElement of this.megaMenuElements) {
				megaMenuElement.style.top = `${this.bottomFromTopOfViewport - paddingOffset}px`;
			}
		}
	}

	openDesktopSearch = () => {
		this.navigationContainerElement.classList.add(this.constructor.desktopSearchOpenClass);
	}

	closeDesktopSearch = () => {
		this.navigationContainerElement.classList.remove(this.constructor.desktopSearchOpenClass);
	}

	initializeDesktopHeader() {
		this.destroyMobileHeader();
		this.initializedState = 'desktop';
		this.updateDesktopMegaMenuTop();
		document.addEventListener('scroll', this.updateDesktopMegaMenuTop);
		window.addEventListener('resize', this.updateDesktopMegaMenuTop);
		this.formContainerElement.addEventListener('focusin', this.openDesktopSearch);
		this.formContainerElement.addEventListener('focusout', this.closeDesktopSearch);
		this.textInputElement.addEventListener('click', this.openDesktopSearch);
		this.closeSearchElement.addEventListener('click', this.closeDesktopSearch);
	}

	destroyDesktopHeader() {
		if (this.initializedState === 'desktop') {
			this.initializedState = null;
		}
		for (const megaMenuElement of this.megaMenuElements) {
			megaMenuElement.style.top = 'auto';
		}
		this.formContainerElement.removeEventListener('focusin', this.openDesktopSearch);
		this.formContainerElement.removeEventListener('focusout', this.closeDesktopSearch);
		this.textInputElement.removeEventListener('click', this.openDesktopSearch);
		this.closeSearchElement.removeEventListener('click', this.closeDesktopSearch);
		this.closeDesktopSearch();
	}

	//
	// Mobile
	//

	mobileNavTriggerHandler = () => {
		if (document.documentElement.classList.contains(this.constructor.mobileNavOpenClass)) {
			this.closeMobileNav();
		}
		else {
			this.openMobileNav();
		}
	}

	openMobileNav = () => {
		const siteHeaderBoundingRect = this.siteHeaderElement.getBoundingClientRect();
		this.navigationContainerElement.style.height = `calc(calc(var(--vh, 1vh) * 100) - ${siteHeaderBoundingRect.bottom}px)`;
		document.documentElement.classList.add(this.constructor.mobileNavOpenClass);
	}

	closeMobileNav = () => {
		document.documentElement.classList.remove(this.constructor.mobileNavOpenClass);
	}

	initializeMobileHeader() {
		this.destroyDesktopHeader();
		this.initializedState = 'mobile';
		this.mobileNavTriggerElement.addEventListener('click', this.mobileNavTriggerHandler);
		if (!this.traversable) {
			this.traversable = new TraversableMenu({
				selectors: {
					'panels_container': '.traversable-menu',
					'menu_item_active': '.menu-item--active-trail'
				},
				accessibility: {
					'panel_role': ''
				},
				triggers: {
					'parent_text': '<span>Back to [:previous-title:]</span>',
					'top_text': '<span>Back to Main</span>',
					'child_text': '<span>explore</span>'
				},
			});
			this.traversable.initializeFromHTML(".traversable-menu");
		}
	}

	destroyMobileHeader() {
		if (this.initializedState === 'mobile') {
			this.initializedState = null;
			// traversable has no destroy function and it is not needed
			// no need to remove mobile nav trigger click event
			this.closeMobileNav();
			this.navigationContainerElement.style.removeProperty('height');
		}
	}

}

class SiteAlert {

	static get openClass() {
		return 'open';
	}

	static get cookieName() {
		return 'close-alert';
	}

	constructor(siteAlertElement) {
		this.siteAlertElement = siteAlertElement;
		if (this.siteAlertElement) {
			this.closeElement = this.siteAlertElement.querySelector('.alert-teaser__close');
			if (this.closeElement) {
				this.closeElement.addEventListener('click', this.close);
				const existingCookie = getCookie(this.constructor.cookieName);
				if (!existingCookie) {
					this.open();
				}
			}
		}
	}

	open = () => {
		if (!this.siteAlertElement.classList.contains(this.constructor.openClass)) {
			this.siteAlertElement.classList.add(this.constructor.openClass);
			transitionAuto({
				element: this.siteAlertElement,
				property: 'height',
				value: 'auto'
			});
		}
	}
	
	close = () => {
		if (this.siteAlertElement.classList.contains(this.constructor.openClass)) {
			this.siteAlertElement.classList.remove(this.constructor.openClass);
			transitionAuto({
				element: this.siteAlertElement,
				property: 'height',
				value: '0px'
			});
			setCookie(this.constructor.cookieName, 'true', 1);
		}
	}
}

Drupal.behaviors.siteheader = {
	attach: function (context, settings) {
		once('siteheader', '.site-header', context).forEach(
			function (element) {
				const siteHeader = new SiteHeader(element);
			}
		);
	}
};

Drupal.behaviors.sitealert = {
	attach: function (context, settings) {
		once('sitealert', '.alert-teaser', context).forEach(
			function (element) {
				const siteAlert = new SiteAlert(element);
			}
		);
	}
};